module.exports = __webpack_public_path__ + "static/media/play-store-badge.9f1322d1.png";